import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// События баннера биометрии

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventClickBiometry = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Клик на виджет биометрии',
  eventLabel: undefined,
  eventValue: undefined,
});

export const eventShowBiometry = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ виджета биометрии',
  eventLabel: undefined,
  eventValue: undefined,
});

export const eventGoEsiaFromBiometry = (eventLabel: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Переход с виджета биометрии на Госуслуги',
  eventLabel,
  eventValue: undefined,
});
